/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var SynchronousRuntimeContext = /** @class */ (function () {
    function SynchronousRuntimeContext() {
        this.shouldUpdate = false;
        this.isSynchronous = true;
    }
    SynchronousRuntimeContext.prototype.update = function (progress, dontNotify) { };
    return SynchronousRuntimeContext;
}());
export { SynchronousRuntimeContext };
export var SyncRuntimeContext = new SynchronousRuntimeContext();
//# sourceMappingURL=synchronous.js.map